module.exports = __webpack_public_path__ + "media/img/favicon/android-chrome-384x384-3c9e1ed1e90bf0b86fa71d51dd11732a.png";